import styled from "styled-components"
import bgPizza from "./assets/bgPizza.jpg"

export const MainCointainer = styled.main`
display:flex;
background-image: url(${bgPizza});
min-height:100vh ;



`